import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../components/ToastNotification";

export const DefaultErrorNotification = (message?: string, title?: string) => {
  showErrorToast(message ?? "An error occurred", title ?? "Error");
};

export const DefaultWarningNotification = (
  message?: string,
  title?: string
) => {
  showWarningToast(message ?? "Please review the details", title ?? "Warning");
};

export const DefaultSuccessNotification = (
  message?: string,
  title?: string
) => {
  showSuccessToast(
    message ?? "Action completed successfully",
    title ?? "Success"
  );
};
